import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Volunteer = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", city: "", interest: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Name and email are required.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/volunteers`, form);
      toast.success("You're in! We'll reach out about the next outreach.");
      setForm({ name: "", email: "", phone: "", city: "", interest: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="volunteer" data-testid="volunteer" className="relative bg-[#050505] py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <motion.div
          className="lg:col-span-4"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="label mb-5">Join The Team</p>
          <h2 className="font-display uppercase text-white leading-[0.95] text-4xl sm:text-6xl">
            Put your hands to <span className="text-green glow-green">work</span>
          </h2>
          <p className="font-sub text-lg text-zinc-400 mt-6 font-light">
            No experience needed — just a heart to serve. Sign up and we'll bring you on the
            next run through the streets.
          </p>
        </motion.div>

        <motion.form
          onSubmit={submit}
          data-testid="volunteer-form"
          className="lg:col-span-8 lg:col-start-5"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <input data-testid="volunteer-name" className="field" placeholder="Full name *" value={form.name} onChange={set("name")} />
            <input data-testid="volunteer-email" type="email" className="field" placeholder="Email *" value={form.email} onChange={set("email")} />
            <input data-testid="volunteer-phone" className="field" placeholder="Phone" value={form.phone} onChange={set("phone")} />
            <input data-testid="volunteer-city" className="field" placeholder="City" value={form.city} onChange={set("city")} />
          </div>
          <input data-testid="volunteer-interest" className="field mt-6" placeholder="How do you want to help? (food, driving, clothes, donations...)" value={form.interest} onChange={set("interest")} />
          <textarea data-testid="volunteer-message" className="field mt-6" rows={3} placeholder="Anything else we should know?" value={form.message} onChange={set("message")} />
          <button
            data-testid="volunteer-submit"
            disabled={loading}
            className="btn-fill mt-8 border border-green text-green font-sub font-semibold text-lg px-8 py-4 rounded-full flex items-center gap-2 disabled:opacity-60"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : <ArrowRight size={18} />}
            {loading ? "Sending…" : "Sign me up"}
          </button>
        </motion.form>
      </div>
    </section>
  );
};
